import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Table } from "shared/components/Table";
import { WrapperOrderTable } from "./style";
import { useState } from "react";
import { getOrderClients } from "../api/getOrderClients";
import { columnOrderClients } from "../model/columnOrderClients";

export const OrdersTable = ({id}: {id: string}) => {

    const [currentPage, setCurrentPage] = useState(1);
    
    const { isLoading, isError, data } = useQuery({
        queryKey: ["getOrdersClients", id, currentPage], 
        queryFn: () => {
            return getOrderClients(currentPage, id);
        },
        placeholderData: keepPreviousData,
        staleTime: 1000 * 60,
        refetchOnWindowFocus: false
    });
    
    return (
        <>
            {!isLoading && data && (
                <WrapperOrderTable>
                    <Table 
                        className="clientsTable" 
                        data={data.orders}
                        navigation="/booking"
                        columns={columnOrderClients} 
                        columnWidths={['100px']}
                        isLoading={isLoading}
                        isError={isError}
                        totalPages={data.pagination.total_pages}
                        page={currentPage}
                        disableSelection={true}
                        disableSorting={true}
                        onPageChange={(page) => setCurrentPage(page)}
                    />
                </WrapperOrderTable>
            )}
        </>
    )
}